export const AUDIO_STATS_FULL_DECODE_BYTE_LIMIT = 50 * 1024 * 1024;
export const AUDIO_STATS_FALLBACK_SAMPLES = 1000;

export function shouldSkipFullAudioStatsDecode(
  blob: Pick<Blob, 'size'>,
  limit = AUDIO_STATS_FULL_DECODE_BYTE_LIMIT
) {
  return blob.size > limit;
}

export function createFallbackAudioWaveform(
  samples = AUDIO_STATS_FALLBACK_SAMPLES
) {
  return new Array<number>(Math.max(1, Math.floor(samples))).fill(0.35);
}
